export default "__VITE_ASSET__y2W9MO$r__"